<template>
  <v-container
    grid-list-md
  >
    <RoleEditCondition
      :cond="cond"
    />
    <v-layout row>
      <v-flex
        md8
      >
        <MaterialCard
          color="green"
          full-width
        >
          <v-card
            v-for="category in categories"
            :key="category.id"
            full-width
          >
            <v-card-title>
              {{ category.name }}
            </v-card-title>
            <v-container>
              <v-layout wrap>
                <v-flex
                  v-for="auth in category.authorities"
                  :key="auth.id"
                  xs6
                  md4
                >
                  <v-checkbox
                    v-model="auth.active"
                    :label="auth.name"
                    :hint="auth.description"
                    :true-value="true"
                    :falsy-value="false"
                  >
                    <template v-slot:append>
                      <v-icon
                        small
                        @click="selected = auth"
                      >
                        mdi-help
                      </v-icon>
                    </template>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </MaterialCard>
      </v-flex>
      <v-flex
        md4
      >
        <RoleEditDetail
          v-if="selected != null"
          :authority="selected"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { RoleEditCondition, RoleEditDetail } from './components'

export default {
  components: {
    RoleEditCondition,
    RoleEditDetail
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const response = await search(to.query)
      next(vm => {
        vm.init(response)
      })
    } catch (e) {
      next(e)
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      const response = await search(to.query)
      this.init(response)
      next()
    } catch (e) {
      next(e)
    }
  },
  data: () => ({
    cond: {
      name: ''
    },
    allAuthorities: [],
    allCategories: [],
    role: null,
    selected: null
  }),
  computed: {
    categories () {
      const list = []

      let prev = null
      let category = null

      for (const a of this.allAuthorities) {
        if (prev == null || prev.category !== a.category) {
          if (category != null) {
            category.authorities.sort((a, b) => a.name < b.name ? -1 : +1)
          }
          const cat = this.allCategories.filter(c => c.id === a.category)[0]
          category = {
            id: cat.id,
            name: cat.name,
            authorities: []
          }
          list.push(category)
        }
        category.authorities.push({
          id: a.id,
          name: a.name,
          description: a.description,
          active: this.role.authorities.some(_a => _a === a.id)
        })
        prev = a
      }

      return list
    }
  },
  methods: {
    init (value) {
      const { role, categories, authorities } = value
      this.role = role
      this.allCategories = categories
      this.allAuthorities = authorities
    },
    onRoleSelected (item) {
      this.selected = item
    }
  }
}

export const search = async (query) => {
  const response = {
    role: {
      id: 3,
      name: 'PartTimeJob',
      description: 'アルバイト',
      editable: true,
      users: [
        { id: 1, name: 'ユーザー1' },
        { id: 2, name: 'ユーザー2' }
      ],
      authorities: [ 1, 2, 3, 9, 12 ]
    },
    categories: [
      { id: 1, name: '顧客' },
      { id: 2, name: 'センサー' },
      { id: 3, name: 'ユーザー' },
      { id: 4, name: 'グループ' },
      { id: 5, name: '権限' }
    ],
    authorities: [
      {
        id: 1,
        category: 1,
        name: 'リスト作成参照',
        description: 'リスト作成を参照します。'
      },
      {
        id: 2,
        category: 1,
        name: '顧客参照',
        description: '顧客を参照します。'
      },
      {
        id: 3,
        category: 1,
        name: '給油履歴参照',
        description: '給油履歴を参照します。'
      },
      {
        id: 4,
        category: 1,
        name: '顧客修正',
        description: '顧客を修正します。'
      },
      {
        id: 5,
        category: 1,
        name: '給油履歴修正',
        description: '給油履歴を修正します。'
      },
      {
        id: 6,
        category: 1,
        name: 'センサー取り付け',
        description: 'センサーとタンクの紐付けをします。'
      },
      {
        id: 7,
        category: 2,
        name: 'センサー参照',
        description: 'センサーを参照します。'
      },
      {
        id: 8,
        category: 2,
        name: 'センサー修正',
        description: 'センサーを修正します。'
      },
      {
        id: 9,
        category: 3,
        name: 'ユーザー参照',
        description: 'ユーザーを参照します。'
      },
      {
        id: 10,
        category: 3,
        name: 'ユーザー修正',
        description: 'ユーザーを修正します。'
      },
      {
        id: 11,
        category: 4,
        name: 'グループ参照',
        description: 'グループを参照します。'
      },
      {
        id: 12,
        category: 4,
        name: 'グループ修正',
        description: 'グループを修正します。'
      },
      {
        id: 13,
        category: 5,
        name: '権限参照',
        description: '権限を参照します。'
      },
      {
        id: 14,
        category: 5,
        name: '権限修正',
        description: '権限を修正します。'
      },
      {
        id: 15,
        category: 5,
        name: '権限付与',
        description: '権限をユーザーに付与します。'
      }
    ]
  }

  return response
}
</script>
